import { render } from "./SocialMediaSection.vue?vue&type=template&id=98c281f2"
import script from "./SocialMediaSection.vue?vue&type=script&lang=js"
export * from "./SocialMediaSection.vue?vue&type=script&lang=js"

import "./SocialMediaSection.vue?vue&type=style&index=0&id=98c281f2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__